import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _startsWithInstanceProperty from "@babel/runtime-corejs3/core-js/instance/starts-with";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//

import moment from "moment";
import { mapActions, mapState } from "vuex";
import { Fragment } from "vue-fragment";
import numeral from "numeral";
import { browserNotSupported } from "@Shared/@Utils/utils";
import { CHECK_SUBDOMAIN } from "./main/store/account/account-actions";
import PendoUtils from "@Shared/@Utils/pendo";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "App",
  components: {
    Fragment
  },
  data() {
    return {
      isSupportedBrowser: true
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState("AccountStore", {
    token: "token",
    localeLanguage(state) {
      return state.accountDetails.localeLanguage;
    }
  })), {}, {
    preferredLocale() {
      let navigatorLocale = "en-CA";
      if (/^fr\b/.test(navigator.language)) {
        navigatorLocale = "fr-CA";
      }
      return this.token ? this.localeLanguage : navigatorLocale;
    },
    rawLocale() {
      return this.preferredLocale.replace("-CA", "");
    }
  }),
  watch: {
    preferredLocale: {
      immediate: true,
      handler(locale) {
        this.$root.$i18n.locale = locale;
      }
    },
    "$root.$i18n.locale": {
      immediate: true,
      handler(locale) {
        this.configurePluginsLocale(locale.replace("-CA", ""));
      }
    }
  },
  created() {
    var _context, _context2, _context3;
    if (_includesInstanceProperty(_context = window.location.href).call(_context, "nylas-callback")) {
      window.location.replace(`${window.location.origin}/#/personal-settings/account/email-preferences${window.location.search}`);
    }
    if (_includesInstanceProperty(_context2 = window.location.href).call(_context2, "nylas-scheduler")) {
      window.location.replace(`${window.location.origin}/#/dashboard${window.location.search}`);
    }
    if (_includesInstanceProperty(_context3 = window.location.href).call(_context3, "email-preferences-scheduler")) {
      const replacedQuery = window.location.search.replace("code=", "redirect=");
      window.location.replace(`${window.location.origin}/#/personal-settings/account/email-preferences${replacedQuery}`);
    }
  },
  async beforeMount() {
    await this.CHECK_SUBDOMAIN();
  },
  mounted() {
    this.$auth.init(this);
    this.$socket.init(this.$auth);
    this.checkUnsupportedBrowsers();
    PendoUtils.prepare();
  },
  methods: _objectSpread(_objectSpread({}, mapActions("AccountStore", [CHECK_SUBDOMAIN])), {}, {
    configurePluginsLocale(rawLocale) {
      this.initFreshchat(rawLocale);
      $.fn.datepicker.defaults.language = rawLocale;
      $.fn.select2.defaults.set("language", rawLocale);
      moment.locale(rawLocale);
      window.Parsley.setLocale(rawLocale);
      $.summernote.options.lang = rawLocale === "fr" ? "fr-FR" : "en-US";
      numeral.locale(rawLocale === "fr" ? "fr-ca" : rawLocale);
    },
    initFreshchat(locale) {
      var _context4;
      //avoid calling freshchat in broker portal widgets
      if (!_startsWithInstanceProperty(_context4 = window.location.hash).call(_context4, "#/widgets")) {
        window.fcWidget.init({
          token: "40a38969-db86-4fcc-8a7b-90f18271e021",
          host: "https://wchat.freshchat.com",
          locale: locale === "fr" ? "fr" : "en-us",
          config: {
            headerProperty: {
              backgroundColor: "#c137a2",
              foregroundColor: "#FFFFFF",
              backgroundImage: "https://wchat.freshchat.com/assets/images/texture_background_1-bdc7191884a15871ed640bcb0635e7e7.png"
            }
          }
        });
      }
    },
    checkUnsupportedBrowsers() {
      this.isSupportedBrowser = !browserNotSupported("broker");
    }
  })
});